// extracted by mini-css-extract-plugin
export default {"StrollerDetailRating":"xy_a bic_a bic_x","StrollerDetailRating__muted":"xy_b bic_fo"};